import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

export function EditStatusUserModal({
  isLoadingEditUserStatus,
  isEditStatusModal,
  data,
  formikEditStatusUser,
  onClickOfEditStatusCancelButton,
}) {
  const { firstname = "-", lastname = "-" } = data;

  return (
    <>
      <Modal
        show={isEditStatusModal}
        onHide={onClickOfEditStatusCancelButton}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {`Edit User Status - ${firstname} ${lastname}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center pb-0">
          <form
            onSubmit={formikEditStatusUser.handleSubmit}
            onReset={formikEditStatusUser.handleReset}
          >
            <div className="row">
              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formikEditStatusUser.getFieldProps("status")}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {formikEditStatusUser.touched.status &&
                formikEditStatusUser.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formikEditStatusUser.errors.status}
                  </div>
                ) : null}
              </div>
            </div>

            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8">
              <Button
                type="submit"
                disabled={formikEditStatusUser.isSubmitting}
                variant="btn btn-success mr-3"
              >
                {`Edit Status`}
                {isLoadingEditUserStatus && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={onClickOfEditStatusCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
